import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { colors, fontFamilies } from '../../components/baseStyle/Variables';
import Button from '../../components/button/Button';
import Header from '../../components/header/Header';
import { Dealer, FormTypes } from '../../gql/graphql';
import { inIframe, modalResolver } from '../../helpers';
import { ExitCodes, modalLoaderHelper, ModalMessage, ModalMessageFailure } from '../../helpers/modal/modal.helper';
import { currentDomain } from '../../helpers/window/window.helpers';
import { SegmentProps } from '../../state-machine/actions/segment';
import { Trans, useTranslation } from 'react-i18next';

const ErrorWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: ${fontFamilies.gilroyRegular};
  justify-content: center;
  margin: 0 auto;
  padding: 0 2rem 2rem;
`;

const Container = styled.div`
  text-align: left;
  position: relative;
`;

const HeadingWrap = styled.div`
  margin-bottom: 1rem;
`;

// TODO Move the button style to Chimera
const ButtonWrap = styled.div`
  margin: 50px 0;

  & button {
    font-family: ${fontFamilies.gilroySemiBold};
    font-size: 1.3rem;
    font-weight: normal;
    margin-top: 0.5rem;
    height: 58px;
  }
`;

type Props = SegmentProps & {
  orderId: string;
  dealer: Dealer;
  highestSupportedApplicationMilestone: number;
};

const NotAllowedToCreateNewApplications: React.FC<Props> = ({ orderId, dealer, highestSupportedApplicationMilestone, track, page, identify }) => {
  const { t } = useTranslation();
  const domains = dealer.domains;
  const storeName = dealer?.storeName;

  useEffect(() => {
    page('Applications Restricted');
    track('Not Allowed To Create New Applications', { orderId });

    const sendDomain = domains ? domains : [currentDomain()];
    modalLoaderHelper({ stopSpinner: true }, sendDomain);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCloseModal = () => {
    const payload: ModalMessage = {
      wcfSuccess: false,
      closeModal: true,
      payload: {
        reason: 'modal closed',
        reasonCode: ExitCodes.generalCloseModal,
        orderId: orderId,
      } as ModalMessageFailure,
    };
    modalResolver(payload, domains);
  };
  return (
    <>
      <Header
        orderId={orderId}
        dealer={dealer}
        goBackFunc={undefined}
        currentNode={['NotAllowedToCreateNewApplications']}
        highestSupportedApplicationMilestone={highestSupportedApplicationMilestone}
        track={track}
        page={page}
        identify={identify}
      />
      <ErrorWrapper id="NotAllowedToCreateNewApplications">
        <Container>
          <HeadingWrap>
            <h2>{t(($) => $.pageNotAllowedToCreateNewApplications.sorry)}</h2>
          </HeadingWrap>
          <p data-testid="message-body" style={{ color: colors.darkBlue, fontSize: '1.1rem', lineHeight: '24px' }}>
            <Trans
              i18nKey={($) => $.pageNotAllowedToCreateNewApplications.notCurrentlyAcceptingApplicationsForThisStore}
              values={{ storeName }}
              components={{ strong: <strong /> }}
            />
          </p>
          <p style={{ color: colors.darkBlue, fontSize: '1.1rem', lineHeight: '24px' }}>
            <Trans i18nKey={($) => $.pageNotAllowedToCreateNewApplications.reachOutForAssistance}>
              If you need assistance, reach out to our support team at
              <a href="tel:844-937-8275" aria-label={t(($) => $.pageNotAllowedToCreateNewApplications.contactNumber)}>
                844-937-8275
              </a>
              for help.
            </Trans>
          </p>
          {inIframe() && (
            <ButtonWrap>
              <Button onClick={handleCloseModal}>{t(($) => $.pageNotAllowedToCreateNewApplications.exit)}</Button>
            </ButtonWrap>
          )}
        </Container>
      </ErrorWrapper>
    </>
  );
};

export default NotAllowedToCreateNewApplications;
